import { zodResolver } from "@hookform/resolvers/zod";
import ContactValidator from "Validators/Common/Contact";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { z } from "zod";

import Felipe from "Assets/Common/Foto-Felipe.png";

import { HTTPErrorCallback } from "Helpers/Error";

import { UseGlobalLoading } from "Hooks/UseGlobalLoading";
import UseNotification from "Hooks/UseNotification";
import UseServices from "Hooks/UseServices";

import FormWrapper from "Components/Common/FormWrapper";
import Input from "Components/Global/Form/Input";

import * as S from "./styles";

export const PartnerForm = () => {
  const { setLoading } = UseGlobalLoading();
  const { api } = UseServices();
  const { showNotification } = UseNotification();

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [phone, setPhone] = useState("");

  const formSchema = z.object({
    name: ContactValidator.name,
    email: ContactValidator.email,
    phone: ContactValidator.phone,
    message: ContactValidator.message,
  });

  const methods = useForm({
    resolver: zodResolver(formSchema),
  });
  const { register, reset } = methods;

  const submit = async (data) => {
    setLoading(true);

    try {
      await api.post("/contact/submit", data);

      showNotification(
        "success",
        "Sucesso!",
        "Sua mensagem foi enviada com sucesso!",
      );

      setShowConfirmation(true);

      setLoading(false);

      reset();
      setPhone("");
    } catch (error) {
      setLoading(false);
      HTTPErrorCallback(error);
    }
  };

  return (
    <S.Wrapper>
      <S.Title>A SEVENX COMO SUA PARCEIRA</S.Title>
      <S.Container>
        <img src={Felipe} alt="" />
        <p>
          Com intuito de auxiliar empresas que nunca utilizaram recursos
          incentivados como estratégia para potencializar os seus investimentos
          na área de marketing e na área de responsabilidade social e
          corporativa e também empresas que já tem experiência, porém desejam
          otimizar os seus investimentos através das leis federais, estaduais e
          municipais, a Sevenx presta consultoria em leis de incentivo fiscal e
          realiza gestão de recursos incentivados.
        </p>
      </S.Container>
      <FormWrapper {...methods} submit={submit}>
        <S.Form id="contact">
          <h2>Entre em contato</h2>

          <S.InputWrapper>
            <Input
              {...register("name")}
              label="Nome:"
              placeholder="Digite aqui"
            />
            <Input
              {...register("phone")}
              label="Telefone:"
              mask="(99) 99999-9999"
              placeholder="(00) 00000-0000"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </S.InputWrapper>
          <Input
            {...register("email")}
            type="email"
            label="E-mail:"
            placeholder="Digite aqui"
          />
          <Input
            {...register("message")}
            type="textarea"
            height="200px"
            label="Mensagem:"
            placeholder="Digite aqui"
          />
          <S.SendWrapper>
            <button type="submit">Enviar</button>
            {showConfirmation && (
              <span>
                Uma mensagem de confirmação foi enviada para o seu e-mail.
              </span>
            )}
          </S.SendWrapper>
        </S.Form>
      </FormWrapper>
    </S.Wrapper>
  );
};

export default PartnerForm;
